"use client";

import styles from "./number-stepper.module.scss";

export interface NumberStepperProps {
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  label?: string;
  "data-testid"?: string;
}

export function NumberStepper({
  value,
  onChange,
  min = 1,
  max = 365,
  label,
  "data-testid": testId,
}: NumberStepperProps) {
  return (
    <div className={styles.stepper} data-testid={testId} role="group" aria-label={label}>
      {label && <span className={styles.label}>{label}</span>}
      <div className={styles.controls}>
        <button
          type="button"
          className={styles.button}
          onClick={() => onChange(Math.max(min, value - 1))}
          disabled={value <= min}
          aria-label={`Decrease ${label ?? "value"}`}
        >
          &minus;
        </button>
        <span className={styles.value} aria-live="polite">
          {value}
        </span>
        <button
          type="button"
          className={styles.button}
          onClick={() => onChange(Math.min(max, value + 1))}
          disabled={value >= max}
          aria-label={`Increase ${label ?? "value"}`}
        >
          +
        </button>
      </div>
    </div>
  );
}
